import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'

// ✅ Vendor CSS (load first)
import 'bootstrap/dist/css/bootstrap.min.css';
import 'react-toastify/dist/ReactToastify.css';
import 'simplebar-react/dist/simplebar.min.css';
import '@fortawesome/fontawesome-free/css/all.min.css';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import 'remixicon/fonts/remixicon.css';


// ✅ Your project CSS (load after vendors so it overrides them)
import './assets/css/linearicon.css';
import './assets/css/style.css';
import './assets/css/vendors/animate.css';
import "./assets/css/ViewMessageModal.css";

// ✅ Your extra custom styles (highest priority)
import './styles/fontawesome.css';   // your overrides for fontawesome
import './styles/dark-theme.css';    // your dark theme (data-theme=dark)
import './App.css';                  // app-specific styling


import App from './App.jsx'

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 0,
      cacheTime: 0,
      refetchOnWindowFocus: false,
      retry: 0,
    },
  },
});

// Make query client globally available for axios interceptor
window.queryClient = queryClient;

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </StrictMode>,
)
